import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { CheckButtonResponse } from '../../../core/model/button-fields';

@Component({
  selector: 'app-check-input',
  templateUrl: './check-input.component.html',
  styleUrls: ['./check-input.component.css']
})
export class CheckInputComponent implements OnInit {

  _formControlName: string;
  @Input() set formName(_formName: string) {
    this._formControlName = _formName;
  }

  @Input() forms: FormGroup;
  @Input() valueButton: string;
  @Input() functionCheck: Observable<boolean>;
  @Input() description: string;
  @Input() isRequired: boolean;

  @Output() valueButtonChange = new EventEmitter<string>();

  responseCheck: boolean;
  isLoadingCheck = false;
  checking: boolean = undefined;
  hasErrorText = false;
  errorMessageChecking: string;

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
  }

  checkFunction() {
    const value = this.forms.controls[this._formControlName].value;
    if (!value || value == '') {
      if (this.isRequired) {
        this.forms.controls[this._formControlName].setErrors({ 'required': true });
       }
      return;
     }
    if (this.checking !== undefined || !this.forms.controls[this._formControlName].valid) {
      return;
    }
    this.isLoadingCheck = true;
    this.forms.controls[this._formControlName].setErrors({ 'waitingValue': true });
    this.errorMessageChecking = this.translateService.instant('buttonFields.checkButton.checking');

    this.functionCheck.pipe(first()).subscribe((result: any) => {
      this.errorMessageChecking = undefined;

      // La comprobación de AZ devuelve un boolean y la comprobación de contenedor un CheckButtonResponse
      if (typeof result === 'boolean') {
        this.manageAzRequest(result as boolean);
      } else {
        this.manageContainerRequest(result as CheckButtonResponse);
      }

      this.isLoadingCheck = false;
    },
      error => {
        this.checking = false;
        this.isLoadingCheck = false;
      });
  }
  private manageAzRequest(existe: boolean) {
    this.responseCheck = existe;
    if (this.responseCheck) {
      this.forms.controls[this._formControlName].setErrors(null);
    } else {
      this.hasErrorText = true;
      this.forms.controls[this._formControlName].setErrors({ 'incorrectValue': true });
    }
  }
  private manageContainerRequest(checkButtonResponse: CheckButtonResponse) {
    this.responseCheck = checkButtonResponse.existe;
    if (!checkButtonResponse.existe) {
      this.hasErrorText = true;
      this.errorMessageChecking = this.translateService.instant('buttonFields.checkButton.' + checkButtonResponse.error);
      this.forms.controls[this._formControlName].setErrors({ 'incorrectValue': true });
    } else {
      this.forms.controls[this._formControlName].setErrors(null);
    }
    this.checking = checkButtonResponse.existe;
    this.isLoadingCheck = false;
  }

  onModelChange(value: string) {
    this.responseCheck = undefined;
    this.checking = undefined;
    this.hasErrorText = false;
    this.errorMessageChecking = undefined;
    this.forms.controls[this._formControlName].setErrors(null);
    this.valueButtonChange.emit(value);
  }

  showCheckButtonIcon(): boolean {
    return !this.isLoadingCheck && this.checking === undefined;
  }

  showSpinnerRotateIcon(): boolean {
    return this.isLoadingCheck;
  }

  showSuccessIcon(): boolean {
    return this.checking;
  }

  showNoExistIcon(): boolean {
    return this.checking === false;
  }

  manageKeyEnter() {
    if (this.checking === undefined && this.forms.controls[this._formControlName].valid) {
      this.isLoadingCheck = true;
    }
  }
}
